import React from 'react';
import SectionBundleReceiptEntry from '../SectionBundleReceiptEntry';

const ElectricalGoodsBundleReceiptEntry = () => {
  return (
    <SectionBundleReceiptEntry
      sectionName="Electrical Goods"
      sectionDisplayName="Electrical Goods Section"
      backRoute="/sections/electrical-goods"
    />
  );
};

export default ElectricalGoodsBundleReceiptEntry;
